module.exports = __webpack_public_path__ + "static/media/label-1-over.87f748d6.svg";